export default __webpack_public_path__ + "static/slide3-tablet-d9364abc518e38567c542143d3154c9d.png";